// register component(s) with react habitat
import DhsvBlog from './index'

export default { DhsvBlog }
